import { Component, Input, OnInit } from '@angular/core';
import { AppConstant, TranslationData } from 'src/app/shared/utilities/app.constant';
import { ChatMessageTimeComponent } from '../chat-message-time/chat-message-time.component';

@Component({
    selector: 'app-chat-message-event',
    templateUrl: './chat-message-event.component.html',
    styleUrls: ['./chat-message-event.component.scss'],
    imports: [ChatMessageTimeComponent]
})
export class ChatMessageEventComponent implements OnInit {
  @Input() message: AppConstant.Message;
  @Input() previousMessage: AppConstant.Message | undefined;
  @Input() translationData: TranslationData;

  @Input() isMine: boolean;

  @Input() isTyping: boolean = false;
  @Input() template: 'CONTENT' | 'TYPING' = 'CONTENT';
  constructor() { }

  ngOnInit(): void {
  }

}
